import { CDN_IMG_URL } from "@casino/legacy/shared/cdn/url";

const getCdnIcon = (handle = "", extension = ".svg") =>
  `${CDN_IMG_URL}/icons/${handle}${extension}`;

export default getCdnIcon;
